import React from 'react';

import { Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import {
  BASE_DOC_URL_VB,
  DEVELOPER_CLI_GUIDE_URL,
} from 'app/developer-v3/constants';

import CTA from './CTA';

type Props = {
  createAppUrl: string;
};

const CTAWarning = (props: Props) => (
  <CTA>
    <CTA.Header>Need to build an entirely new integration?</CTA.Header>
    <CTA.Body margin="15px 0px 0px">
      <Text tag="p">
        The only time you should need to build a new integration is if you have
        a separate product or if you have an application you don’t want to
        publish to the Zapier app directory. If you need to update your current
        integration, select it from the list below to continue instead. Learn
        more about{' '}
        <Link href={`${BASE_DOC_URL_VB}/manage/versions`} target="_blank">
          creating a new version
        </Link>
        .
      </Text>
      <br />
      <Text tag="p">
        Need a new Zapier integration? Build it visually{' '}
        <Link href={props.createAppUrl}>(Platform UI)</Link> or code it yourself{' '}
        <Link href={DEVELOPER_CLI_GUIDE_URL} target="_blank">
          (Platform CLI)
        </Link>
        .
      </Text>
    </CTA.Body>
  </CTA>
);

export default CTAWarning;
